import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import _ from 'lodash';
import moment from 'moment';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { TimeParserService } from '../../../core/services/time-parser.service';
import { TimeWorkedService } from './services/time-worked.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-time-worked',
  templateUrl: './time-worked.component.html',
  styleUrls: ['./time-worked.component.css']
})
export class TimeWorkedComponent implements OnInit {
  employeeInfo: any;
  portalSettings: any;
  timeParserService: TimeParserService;
  timeWorkedService: TimeWorkedService;
  timeWorkedForm: NgForm;
  @ViewChild('timeWorkedForm') set content(content: NgForm) {
    if (content) { // initially setter gets called with undefined
      this.timeWorkedForm = content;
    }
  }

  allowApproverTimeWorkedEdit: boolean;
  clockStatusesMap: any;
  dailyTimeData: any[];
  dailyTimeLoaded: boolean;
  daysOfWeek: any[];
  employees: any[];
  enableCrews: boolean;
  hasTime: boolean[];
  intervalConfig: number;
  isApprover: boolean;
  isTimecardAdmin: boolean;
  lastTimeWorkedAction: any;
  GPSClockInEnabled: boolean;
  GPSClockInFaultTolerance: number;
  payPeriod: any;
  readOnly: boolean;
  selectedDay: any;
  selectedEmployee: any;
  selectedWeek: any;
  selectedWeeks: any;
  showBreakHours: boolean;
  timecardTotalsByEmployee: any;
  timecardTotalsReady: boolean;
  timeWorked: any[];
  timeWorkedAlert: any;
  timeWorkedCollapsed: boolean = false;
  timeWorkedInitialized: boolean = false;
  timeWorkedSubTotals: any[];
  template: any;
  templateDates: any[];
  weeks: any[];
  defaultBreakHours: any;
  originalTimeWorked: any[];
  dateFormat: string;

  constructor(
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    timeParserService: TimeParserService,
    timeWorkedService: TimeWorkedService,
    utilityService: UtilityService
  ) {
    this.timeParserService = timeParserService;
    this.timeWorkedService = timeWorkedService;
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.dateFormat = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    //TODO create a readonly property
    // for crew grid - crewGridDataService.unsubmittedRows == rowCount
    this.allowApproverTimeWorkedEdit = this.portalSettings.TCAllowApproverTimeWorkedEdit.ConfigValue == "1";
    this.intervalConfig = parseInt(this.portalSettings["TimeSpanInterval"].ConfigValue);
    this.GPSClockInEnabled = this.portalSettings["GPSClockInEnabled"].ConfigValue == "1";
    this.isTimecardAdmin = this.employeeInfo.IsTimecardAdmin;
    this.GPSClockInFaultTolerance = parseInt(this.portalSettings.GPSClockInFaultTolerance.ConfigValue || 0) / 60;
  }

  ngAfterViewInit(): void {
  }

  //public methods to be called by external components
  initTimeWorked(payPeriod) {
    this.timeWorkedInitialized = false;
    this.payPeriod = payPeriod;
    this.template = null;
    this.templateDates = null;
    this.clockStatusesMap = null;
    this.initDailyTime();
    if (payPeriod.IsTimeWorkedEnabled)
      this.getWeeks();
  }

  initDailyTime() {
    this.timecardTotalsByEmployee = null;
    this.timecardTotalsReady = false;
    this.timeWorkedSubTotals = [];
    this.dailyTimeData = null;
    this.dailyTimeLoaded = false;
  }

  setTemplate(template: any) {
    this.template = template;
    this.timeWorkedService.getTemplateDays(template.CrewTemplateID).then((response: any) => {
      let templateDates = [];
      response.forEach((templateDate) => {
        var date = moment(parseInt(templateDate.substr(6))).utc();
        templateDates.push({ Date: date, DisplayDate: date.format(this.dateFormat) });
      });
      this.templateDates = templateDates;
    });
    this.timeWorkedService.getCrewClockInStatus(this.payPeriod.PRPCKeyID, this.template.CrewTemplateID).then((response: any[]) => {
      let clockStatusesMap: any = {};
      response.forEach((val => {
        clockStatusesMap[val.Employee.toString()] = val;
      }));
      this.clockStatusesMap = clockStatusesMap;

      if (this.selectedEmployee != null && this.selectedEmployee != "all" && this.clockStatusesMap[this.selectedEmployee] != null)
        this.isApprover = this.clockStatusesMap[this.selectedEmployee].IsApprover;

    });
  }

  setEmployee(employee: any) {
    this.selectedEmployee = employee;
    this.initDailyTime();
    if (this.selectedEmployee != null && this.selectedEmployee != "all" && this.timeWorkedInitialized)
      this.getDailyTime();

    if (this.clockStatusesMap != null) {
      if (this.selectedEmployee != null && this.selectedEmployee != "all" && this.clockStatusesMap[this.selectedEmployee] != null)
        this.isApprover = this.clockStatusesMap[this.selectedEmployee].IsApprover;
    }

  }

  setEmployeeList(employees: any[]) {
    this.employees = employees;
  }

  calculateSubtotals() {
    if (this.timecardTotalsReady && this.dailyTimeLoaded) {
      var subTotals = [];
      for (var i = 0; i < 7; i++) {
        subTotals[i] = { Subtotal: 0, Difference: 0 };
      }
      //add subtotal amounts
      this.timeWorked.forEach((sequence) => {
        $.each(sequence, (dayNumber, timeEntry) => {
          if ((timeEntry.StartTime != null && timeEntry.StartTime != "") && (timeEntry.StopTime != null && timeEntry.StopTime != "")) {
            var startTime = this.timeParserService.convertTimeString(timeEntry.StartTime);
            var stopTime = this.timeParserService.convertTimeString(timeEntry.StopTime);
            subTotals[dayNumber].Subtotal += (stopTime - startTime);
            if (this.showBreakHours) {
              subTotals[dayNumber].Subtotal -= (timeEntry.BreakHours || 0);
            }

          }
        });
      });
      //calculate differences from timecard allocation
      this.daysOfWeek.forEach((day: any) => {
        //calculate difference from timecard entries
        var dateString = day.DateString;
        var timecardTotal = 0;
        var breakHours = 0;
        var otherTotal = 0;

        if (!jQuery.isEmptyObject(this.timecardTotalsByEmployee) && this.timecardTotalsByEmployee[this.selectedEmployee][dateString] != null) {
          timecardTotal = this.timecardTotalsByEmployee[this.selectedEmployee][dateString].timecardHours;
          otherTotal = this.timecardTotalsByEmployee[this.selectedEmployee][dateString].otherHours;
        }

        subTotals[day.DayNumber].TimecardTotal = timecardTotal;
        subTotals[day.DayNumber].OtherTotal = otherTotal;
        if (subTotals[day.DayNumber].TimecardTotal != 0)
          subTotals[day.DayNumber].TimecardTotal = subTotals[day.DayNumber].TimecardTotal.toFixed(2);
        if (subTotals[day.DayNumber].OtherTotal != 0)
          subTotals[day.DayNumber].OtherTotal = subTotals[day.DayNumber].OtherTotal.toFixed(2);
        if (this.showBreakHours)
          subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Subtotal - timecardTotal - otherTotal + breakHours;
        else
          subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Subtotal - timecardTotal - otherTotal;
        subTotals[day.DayNumber].DifferenceAbs = Math.abs(subTotals[day.DayNumber].Difference);
        if (subTotals[day.DayNumber].Difference != 0)
          subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Difference.toFixed(2);
        if (subTotals[day.DayNumber].Subtotal != 0)
          subTotals[day.DayNumber].Subtotal = subTotals[day.DayNumber].Subtotal.toFixed(2);

        subTotals[day.DayNumber].Text = "<span>Time Worked: " + subTotals[day.DayNumber].Subtotal + "</span></br><span>Time Allocation: " + subTotals[day.DayNumber].TimecardTotal + "</span></br></hr><span>Other Total: " + subTotals[day.DayNumber].OtherTotal + "</span></br></hr><span>Difference: " + subTotals[day.DayNumber].Difference + "</span>";
      });
      this.timeWorkedSubTotals = subTotals;
    }

  }

  //Note - calculating employee totals must be performed on the specific pages itself
  setTimecardTotalsByEmployee(timecardTotalsByEmployee: any) {
    this.timecardTotalsByEmployee = timecardTotalsByEmployee;
    this.timecardTotalsReady = true;
    this.calculateSubtotals();
  }

  closeTimeWorkedAlert() {
    this.timeWorkedAlert = null;
  }

  //Only used in standard timecard to update route - possible deprecation?
  dayChanged() {

  }

  setReadOnly(readOnly) {
    this.readOnly = readOnly;
  }

  weekChanged() {
    this.getDailyTime();
  }

  private getWeeks() {
    this.timeWorkedService.getWeeks(this.payPeriod.PRPCKeyID).then((response: any[]) => {
      this.weeks = response;
      let USCountryMode = this.portalSettings["CountryDateCode"].ConfigValue != "US";
      $.each(this.weeks, (weekKey, week) => {
        var startDate = moment.utc(week.WeekBeginDate);
        var startDateDisplay, endDateDisplay;
        if (USCountryMode)
          startDateDisplay = startDate.format("DD/MM");
        else
          startDateDisplay = startDate.format("MM/DD");
        var endDate = moment.utc(week.WeekEndDate);
        if (USCountryMode)
          endDateDisplay = endDate.format("DD/MM");
        else
          endDateDisplay = endDate.format("MM/DD");
        var displayValue = "Week of: " + startDateDisplay + " - " + endDateDisplay;
        this.weeks[weekKey].StartDate = startDate;
        this.weeks[weekKey].EndDate = endDate;
        this.weeks[weekKey].DisplayValue = displayValue;
      });
      if (this.weeks.length > 0) {
        this.defaultBreakHours = this.weeks[0].DefaultBreakHours;
        this.showBreakHours = this.weeks[0].ShowBreakHours;
      }
      this.selectedWeek = this.weeks.length > 0 ? this.weeks[0] : null;
      if (this.selectedWeek != null && this.selectedEmployee != null && this.selectedEmployee != "all")
        this.getDailyTime();
      this.timeWorkedInitialized = true;
    });
  }

  private getDailyTime() {
    if (this.selectedEmployee != null) {
      this.dailyTimeLoaded = false;
      this.timeWorkedService.getDailyTime(this.selectedEmployee, this.payPeriod.PRPCKeyID, this.selectedWeek.StartDate.format("MM/DD/YYYY"), this.selectedWeek.EndDate.format("MM/DD/YYYY")).then((response: any) => {
        let dailyTimeData = response;
        $.each(dailyTimeData, (key, dailyTime) => {
          dailyTimeData[key].Date = moment.utc(dailyTime.Date);
          if (dailyTime.StartTime != null) {
            let startTime = moment.utc(dailyTime.StartTime).format("hh:mm A");
            dailyTimeData[key].StartTime = startTime;
          }

          if (dailyTime.StopTime != null) {
            let stopTime = moment.utc(dailyTime.StopTime).format("hh:mm A");
            dailyTimeData[key].StopTime = stopTime;
          }

          dailyTimeData[key].DayOfWeek = dailyTimeData[key].Date.day();
        });
        this.dailyTimeData = dailyTimeData;
        this.groupDailyTime();
      });
    }
  }

  private groupDailyTime() {
    this.daysOfWeek = [];
    this.selectedDay = null;
    for (var i = 0; i < 7; i++) {
      var dayOfWeek = new Date(this.selectedWeek.StartDate.year(), this.selectedWeek.StartDate.month(), this.selectedWeek.StartDate.date());
      dayOfWeek.setDate(dayOfWeek.getDate() + i);
      var day;
      var dayNumber = dayOfWeek.getDay();
      switch (dayNumber) {
        case 0:
          day = "Sun"
          break;
        case 1:
          day = "Mon"
          break;
        case 2:
          day = "Tues"
          break;
        case 3:
          day = "Wed"
          break;
        case 4:
          day = "Thurs"
          break;
        case 5:
          day = "Fri"
          break;
        case 6:
          day = "Sat"
          break;
      }

      if (this.portalSettings["CountryDateCode"].ConfigValue == "US")
        day = day + " " + (dayOfWeek.getMonth() + 1) + "/" + dayOfWeek.getDate();
      else
        day = day + " " + dayOfWeek.getDate() + "/" + (dayOfWeek.getMonth() + 1);
      var dayMoment = moment(dayOfWeek);
      var dateString = dayMoment.format("YYYY-MM-DD");
      this.daysOfWeek.push({ Date: dayOfWeek, Day: day, DayNumber: dayNumber, DateValue: (dayOfWeek.getMonth() + 1) * 100 + dayOfWeek.getDate(), DateString: dateString });
    }
    if (this.selectedDay == null)
      this.selectedDay = this.daysOfWeek.length > 0 ? this.daysOfWeek[0] : null;
    this.timeWorked = [];
    this.dailyTimeData.forEach((dailyTime) => {
      if (this.timeWorked[dailyTime.Seq - 1] == null) {
        this.timeWorked[dailyTime.Seq - 1] = [];
      }
      this.timeWorked[dailyTime.Seq - 1][dailyTime.DayOfWeek] = dailyTime;
    });

    for (var i = 0; i < this.timeWorked.length; i++) {
      if (this.timeWorked[i] == null) {
        this.timeWorked[i] = [];

      }
      //fill out missing date info
      for (var j = 0; j < this.daysOfWeek.length; j++) {
        if (this.timeWorked[i][j] == null) {
          this.timeWorked[i][j] = { Date: this.daysOfWeek[j].Date, DayOfWeek: this.daysOfWeek[j].DayNumber };
        }
      }
    }
    if (this.timeWorked.length == 0) {
      this.timeWorked[0] = [];
      for (var i = 0; i < this.daysOfWeek.length; i++) {
        this.timeWorked[0][i] = { Date: this.daysOfWeek[i].Date, DayOfWeek: this.daysOfWeek[i].DayNumber };
      }
    }
    this.originalTimeWorked = _.cloneDeep(this.timeWorked);
    while (this.timeWorked.length < 2) {
      this.addSequence();
    }
    this.dailyTimeLoaded = true;
    this.updateHasTime();
    this.calculateSubtotals();
  }

  addSequence() {
    var seq = [];
    for (var j = 0; j < this.daysOfWeek.length; j++) {
      seq[j] = { Date: this.daysOfWeek[j].Date, DayOfWeek: this.daysOfWeek[j].DayNumber };
    }
    this.timeWorked.push(seq);
    this.originalTimeWorked.push(_.cloneDeep(seq));
  }

  updateHasTime() {
    var hasTime = [];
    this.timeWorked.forEach((sequence) => {
      $.each(sequence, (dayNumber, timeEntry) => {
        if ((timeEntry.StartTime != null && timeEntry.StartTime != "") || (timeEntry.StopTime != null && timeEntry.StopTime != "")) {
          hasTime[dayNumber] = true;
        }
      });
    })

    this.hasTime = hasTime;
  }

  saveTimeWorked(time, day, sequence) {
    this.closeTimeWorkedAlert();
    if (this.timeWorkedForm.valid) {
      this.timeWorkedAlert = null;
      if (time != null && this.timeChanged(time, day, sequence)) {
        let action;
        if ((time.StartTime == null || time.StartTime == "") && (time.StopTime == null || time.StopTime == "")) {
          action = "delete";
        }
        else {
          action = "save";
        }
        sequence += 1;
        if (action == "save") {
          //check for time overlap
          if (this.timeWorkedValid(time, day, sequence)) {
            //check for time interval setting

            let intervalValid = false;
            let startMinutes = time.StartTime != null ? parseInt(time.StartTime.substr(time.StartTime.indexOf(":") + 1, 2)) : null;
            let stopMinutes = time.StopTime != null ? parseInt(time.StopTime.substr(time.StopTime.indexOf(":") + 1, 2)) : null;
            switch (this.intervalConfig) {
              case 0:
                intervalValid = true;
                break;
              case 15:
                if (startMinutes == 0 || startMinutes == 15 || startMinutes == 30 || startMinutes == 45)
                  intervalValid = true;
                break;
              case 30:
                if (startMinutes == 0 || startMinutes == 30)
                  intervalValid = true;
                break;
              case 60:
                if (startMinutes == 0)
                  intervalValid = true;
                break;
            }
            if (intervalValid) {
              let mm = day.Date.getMonth() + 1;
              if (mm < 10)
                mm = "0" + mm;
              let dd = day.Date.getDate();
              if (dd < 10)
                dd = "0" + dd;
              let insertDate = mm + "/" + dd + "/" + day.Date.getFullYear();
              this.timeWorkedService.insertUpdateTime(
                this.selectedEmployee,
                this.payPeriod.PRPCKeyID,
                insertDate,
                time.StartTime,
                time.StopTime,
                sequence,
                time.Notes,
                time.BreakHours
              ).then((response: any) => {
                if (response.success) {
                  if (this.showBreakHours && (time.StartTime == null || time.StopTime == null || time.StartTime == "" || time.StopTime == "") && (time.BreakHours == null || time.BreakHours == "") && sequence == 1)
                    time.BreakHours = this.defaultBreakHours;

                  this.timeWorkedForm.form.markAsPristine();
                  this.originalTimeWorked[sequence - 1][day.DayNumber].StartTime = time.StartTime;
                  this.originalTimeWorked[sequence - 1][day.DayNumber].StopTime = time.StopTime;
                  this.originalTimeWorked[sequence - 1][day.DayNumber].BreakHours = time.BreakHours;
                  this.updateHasTime();
                  this.calculateSubtotals();
                }
                else {
                  this.timeWorkedAlert = { type: "danger", msg: response.error }
                }
              });
            }
            else {
              this.timeWorkedAlert = { type: "danger", msg: "Time worked not saved. Minutes must be in intervals of " + this.intervalConfig + "." };
            }

          }
          else {
            this.timeWorkedAlert = { type: "danger", msg: "Your time entry overlaps with an existing entry or your time was invalid. Time worked not saved" };
          }

        }
        else if (action == "delete") {
          let mm = day.Date.getMonth() + 1;
          if (mm < 10)
            mm = "0" + mm;
          let dd = day.Date.getDate();
          if (dd < 10)
            dd = "0" + dd;
          let insertDate = mm + "/" + dd + "/" + day.Date.getFullYear();
          this.timeWorkedService.deleteTime(
            this.selectedEmployee,
            this.payPeriod.PRPCKeyID,
            insertDate,
            sequence
          ).then((response) => {
            this.timeWorkedForm.form.markAsPristine();
            this.originalTimeWorked[sequence - 1][day.DayNumber].StartTime = time.StartTime;
            this.originalTimeWorked[sequence - 1][day.DayNumber].StopTime = time.StopTime;
            this.updateHasTime();
            this.calculateSubtotals();
          });
        }
        else {
        }
      }
    }
  }

  private timeChanged(time, day, sequence) {
    if (this.originalTimeWorked[sequence][day.DayNumber].StartTime != time.StartTime)
      return true;
    if (this.originalTimeWorked[sequence][day.DayNumber].StopTime != time.StopTime)
      return true;
    if (this.originalTimeWorked[sequence][day.DayNumber].BreakHours != time.BreakHours)
      return true;
    return false;
  }

  private timeWorkedValid(time, day, seq) {
    let timeValid = true;
    if (time.StartTime != null && time.StartTime != "" && time.StopTime != null && time.StopTime != "") {
      let start = this.timeParserService.convertTimeString(time.StartTime);
      let stop = this.timeParserService.convertTimeString(time.StopTime);
      if (start > stop && stop != 0) {
        return false;
      }
    }
    this.timeWorked.forEach((currentSequence, sequenceIndex) => {
      if (seq != sequenceIndex + 1) {
        if (currentSequence[day.DayNumber] != null) {
          if (currentSequence[day.DayNumber].StartTime != null && currentSequence[day.DayNumber].StartTime != "" &&
            currentSequence[day.DayNumber].StopTime != null && currentSequence[day.DayNumber].StopTime != "") {
            var startTime = this.timeParserService.convertTimeString(currentSequence[day.DayNumber].StartTime);
            var stopTime = this.timeParserService.convertTimeString(currentSequence[day.DayNumber].StopTime);
            if (time.StartTime != null && time.StartTime != "") {
              var currStartTime = this.timeParserService.convertTimeString(time.StartTime);
              if ((currStartTime >= startTime) && (currStartTime < stopTime)) {
                timeValid = false;
                return false;
              }
            }
            if (time.StopTime != null && time.StopTIme != "") {
              var currStopTime = this.timeParserService.convertTimeString(time.StopTime);
              if ((currStopTime > startTime) && (currStopTime <= stopTime)) {
                timeValid = false;
                return false;
              }
            }
          }
        }
      }
    });
    return timeValid;
  }

  //timecard submission validation
  async verifyTimeWorked() {
    let employeeString = "";
    //used to keep track of which employees are valid for submission
    let validEmployees;
    let invalidErrors = [];
    let unbalancedErrors = [];
    //TODO - get a list of employees
    if (this.selectedEmployee == null || this.selectedEmployee == "all") {
      let employees = this.employees.slice(1);
      validEmployees = employees.map(function (elem) {
        if (elem.Value != "all") {
          return parseInt(elem.Value);
        }
      });

      employeeString = validEmployees.join(",");
    }
    else {
      validEmployees = [parseInt(this.selectedEmployee)];
      employeeString = this.selectedEmployee;
    }

    let response: any = await this.timeWorkedService.getDailyTime(employeeString, this.payPeriod.PRPCKeyID);

    let dailyTimeData = response;
    $.each(dailyTimeData, (key, dailyTime) => {
      dailyTimeData[key].Date = moment.utc(dailyTime.Date);

      if (dailyTime.StartTime != null) {
        let startTime = moment.utc(dailyTime.StartTime).format("hh:mm A");
        dailyTimeData[key].StartTime = startTime;
      }

      if (dailyTime.StopTime != null) {
        let stopTime = moment.utc(dailyTime.StopTime).format("hh:mm A");
        dailyTimeData[key].StopTime = stopTime;
      }

      dailyTimeData[key].DayOfWeek = dailyTimeData[key].Date.day();
    });
    //compare time worked with timecard lines
    let subTotals = {};

    //iterate over time worked entries and calculate their subtotals
    dailyTimeData.forEach((dailyTime) => {
      let dateString = dailyTime.Date.format("YYYY-MM-DD");
      let containsDate = false;
      //TODO - pass in template dates
      if (this.templateDates.length > 0) {
        for (let i = 0; i < this.templateDates.length; i++) {
          if (moment.utc(dateString, "YYYY-MM-DD").isSame(this.templateDates[i].Date, "day")) {
            containsDate = true;
          }
        }
      }
      if (containsDate) {
        if ((dailyTime.StartTime != null && dailyTime.StartTime != "") && (dailyTime.StopTime != null && dailyTime.StopTime != "")) {
          if (subTotals[dailyTime.Employee] == null) {
            subTotals[dailyTime.Employee] = {};
            subTotals[dailyTime.Employee][dateString] = { Subtotal: 0, Difference: 0 };
          }
          if (subTotals[dailyTime.Employee][dateString] == null) {
            subTotals[dailyTime.Employee][dateString] = { Subtotal: 0, Difference: 0 };
          }
          let startTime = this.timeParserService.convertTimeString(dailyTime.StartTime);
          let stopTime = this.timeParserService.convertTimeString(dailyTime.StopTime);
          subTotals[dailyTime.Employee][dateString].Subtotal += +(stopTime - startTime);
          if (dailyTime.ShowBreakHours) {
            subTotals[dailyTime.Employee][dateString].Subtotal -= (dailyTime.BreakHours || 0);
          }
          //calculate difference from timecard entries
          let date = dailyTime.Date;
          let timecardTotal = { timecardHours: 0, otherHours: 0 };
          if (this.timecardTotalsByEmployee[dailyTime.Employee][dateString] != null) {
            timecardTotal = this.timecardTotalsByEmployee[dailyTime.Employee][dateString];
          }
          subTotals[dailyTime.Employee][dateString].TimecardTotal = timecardTotal.timecardHours;
          subTotals[dailyTime.Employee][dateString].OtherTotal = timecardTotal.otherHours;
          subTotals[dailyTime.Employee][dateString].Difference = parseFloat((subTotals[dailyTime.Employee][dateString].Subtotal - timecardTotal.timecardHours - timecardTotal.otherHours).toFixed(2));
          subTotals[dailyTime.Employee][dateString].DifferenceAbs = Math.abs(subTotals[dailyTime.Employee][dateString].Difference);
        }
        else if ((dailyTime.StartTime != null && dailyTime.StartTime != "") || (dailyTime.StopTime != null && dailyTime.StopTime != "")) {
          //If start time and stop time don't both exist, time worked is invalid
          if (validEmployees.indexOf(dailyTime.Employee) > -1) {
            validEmployees.splice(validEmployees.indexOf(dailyTime.Employee), 1);
            invalidErrors.push(dailyTime.Employee);
          }
        }
      }

    });

    //iterate over timecard totals and add them to subtotal collection (adds entries that were missed by time worked calc in the last step)
    if (this.selectedEmployee == null || this.selectedEmployee == "all") {
      $.each(this.timecardTotalsByEmployee, (employee, totalsByEmployee) => {
        $.each(totalsByEmployee, (dateString, total) => {
          if (subTotals[employee] == null) {
            subTotals[employee] = {};
          }
          if (subTotals[employee][dateString] == null) {
            subTotals[employee][dateString] = { Subtotal: 0, Difference: total.totalHours * -1, TimecardTotal: total.timecardHours, OtherTotal: total.otherHours };
          }
        });
      })

    }
    else {
      $.each(this.timecardTotalsByEmployee[this.selectedEmployee], (dateString, total) => {
        if (subTotals[this.selectedEmployee] == null) {
          subTotals[this.selectedEmployee] = {};
        }
        if (subTotals[this.selectedEmployee][dateString] == null) {
          subTotals[this.selectedEmployee][dateString] = { Subtotal: 0, Difference: total.totalHours * -1, TimecardTotal: total.totalHours, OtherTotal: 0 };
        }
      });
    }
    $.each(subTotals, (employee, employeeSubtotals) => {
      if (validEmployees.indexOf(parseInt(employee)) > -1) {
        $.each(employeeSubtotals, (key, val: any) => {
          let containsDate = false;
          if (this.templateDates.length > 0) {
            for (let i = 0; i < this.templateDates.length; i++) {
              if (moment.utc(key, "YYYY-MM-DD").isSame(this.templateDates[i].Date, "day")) {
                containsDate = true;
              }
            }
          }
          if (this.templateDates.length == 0 || containsDate) {
            if (val.Difference != 0 && validEmployees.indexOf(parseInt(employee)) > -1) {
              if (Math.abs(val.Difference) > this.GPSClockInFaultTolerance) {
                validEmployees.splice(validEmployees.indexOf(parseInt(employee)), 1);
                unbalancedErrors.push(parseInt(employee));
                return false;
              }

            }
          }

        });
      }
    });
    if (unbalancedErrors.length == 0 && invalidErrors.length == 0) {
      return { Success: true, Error: null };
    }
    else {
      let errorMessage = "Could not submit timecard.";
      if (invalidErrors.length > 0) {
        errorMessage += "</br>Time worked invalid for employees: " + invalidErrors.join(",");
      }
      if (unbalancedErrors.length > 0) {
        errorMessage += "</br>Time worked does not match up with time allocation for employees: " + unbalancedErrors.join(",");
      }
      return { Success: false, Error: { type: "danger", msg: errorMessage } };
    }

  }
}
